const palette = {
    colors: {
        header: {
            light: "#1e293b",
            dark: "#0f172a",
        },
        accent: {
            light: "#1e293b",
            dark: "#f1f5f9",
        },
        background: {
            light: {
                normal: "#f1f5f9",
                lightest: "#ffffff",
                lighter: "#f8fafc",
                darker: "#e2e8f0",
                darkest: "#cbd5e1"
            },
            dark: {
                normal: "#1e293b",
                lightest: "#334155",
                lighter: "#293548",
                darker: "#1a2332",
                darkest: "#0f172a",
            }
        },
        colorScheme: {
            light: {
                info: "#3b82f6",
                success: "#22c55e",
                warning: "#f59e0b",
                danger: "#ef4444",
            },
            dark: {
                info: "#60a5fa",
                success: "#4ade80",
                warning: "#fbbf24",
                danger: "#f87171",
            },
        },
        backgroundHover: {
            light: "#e2e8f0",
            dark: "#293548",
        },
        text: {
            light: "#1e293b",
            dark: "#f1f5f9",
        },
        accentText: {
            light: "#f1f5f9",
            dark: "#1e293b",
        },
    },
};

export default palette;
